// LÓGICA DO BUNDLE DE QUANTIDADES E SABORES
//
// O carrinho real só é acionado em dois momentos:
//   1. Uma vez por sessão, pra descobrir o desconto real por quantidade
//      (testa 1, 2 e 3 unidades isoladamente e guarda o resultado em
//      sessionStorage — navegações seguintes na mesma sessão reaproveitam
//      isso, sem rede e sem loading).
//   2. No clique de "Adicionar ao carrinho", que aplica de fato a seleção
//      (mesclada com o que já existia no carrinho, sem afetar outros produtos).
// Enquanto o cliente só está escolhendo quantidade/sabor, o subtotal é
// calculado localmente (preço de cada variante já vem no HTML + % de
// desconto já descoberto), então é instantâneo — sem chamada de rede.
;(function () {
    var container = document.querySelector('.pdp-bundle-container')
    if (!container) return

    var cards = container.querySelectorAll('.pdp-flavor-card')
    var fillLine = container.querySelector('.pdp-progress-line-fill')
    var steps = container.querySelectorAll('.pdp-progress-step')
    var bottomCols = Array.from(container.querySelectorAll('.pdp-progress-step-bottom > div'))
    var topCols = Array.from(container.querySelectorAll('.pdp-progress-step-top > div'))
    var subtotalPrices = container.querySelector('.pdp-subtotal-prices')
    var subtotalCompare = container.querySelector('.pdp-subtotal-compare')
    var subtotalCurrent = container.querySelector('.pdp-subtotal-current')
    var submitBtn = container.querySelector('.pdp-cart-btn')
    if (!submitBtn || !subtotalCurrent) return

    var freeShippingMinCents = parseInt(container.getAttribute('data-free-shipping-min-cents'), 10) || 0
    var freeShippingTagText = container.getAttribute('data-free-shipping-tag-text') || ''

    var discountTagEls = {
        1: container.querySelector('[data-pdp-discount-tag="tier1-tag"]'),
        2: container.querySelector('[data-pdp-discount-tag="tier2-tag"]'),
        3: container.querySelector('[data-pdp-discount-tag="tier3-tag"]'),
    }

    var submitBtnText = submitBtn.querySelector('.pdp-cart-btn-text')
    if (!submitBtnText) return

    var originalBtnText = submitBtnText.textContent
    var originalBtnBg = submitBtn.style.backgroundColor

    var trackedIds = []
    var probeReferenceId = null
    var priceByVariant = {}
    cards.forEach(function (card) {
        var vid = card.getAttribute('data-variant-id')
        trackedIds.push(vid)
        priceByVariant[vid] = parseInt(card.getAttribute('data-variant-price'), 10) || 0
        if (!probeReferenceId && card.getAttribute('data-variant-available') === 'true') {
            probeReferenceId = vid
        }
    })
    if (!probeReferenceId) probeReferenceId = trackedIds[0]

    // Estado real e conhecido do carrinho inteiro (variantId -> quantidade), inclui itens de fora do widget.
    var originalCart = {}
    // Seleção local do cliente neste widget (variantId rastreada -> quantidade), ainda não confirmada.
    var widgetState = {}
    trackedIds.forEach(function (vid) { widgetState[vid] = 0 })

    var initialized = false
    var probingDone = false
    var preview = { currentCents: 0, compareCents: 0 }
    // Resultado real do desconto percentual (testado com 1, 2 e 3 unidades via rede)
    // — usado pro texto/visibilidade das tags E pro cálculo local do subtotal,
    // independente da seleção do cliente. Frete grátis NÃO entra aqui: não depende
    // de nenhuma requisição (é só preço x quantidade vs. valor mínimo), então é
    // calculado direto por freeShippingInfoForQty(), sem cache nem espera de rede.
    var tierDiscountInfo = {
        1: { hasDiscount: false, discountPercent: 0 },
        2: { hasDiscount: false, discountPercent: 0 },
        3: { hasDiscount: false, discountPercent: 0 },
    }

    function freeShippingInfoForQty(qty) {
        var subtotalCents = (priceByVariant[probeReferenceId] || 0) * qty
        return freeShippingMinCents > 0 && subtotalCents >= freeShippingMinCents
    }

    var CACHE_TTL_MS = 20 * 60 * 1000
    var cacheKey = 'jui_pdp_tier_discount_' + (container.getAttribute('data-product-id') || 'default')

    function readDiscountCache() {
        try {
            var raw = sessionStorage.getItem(cacheKey)
            if (!raw) return null
            var parsed = JSON.parse(raw)
            if (!parsed || !parsed.savedAt || Date.now() - parsed.savedAt > CACHE_TTL_MS) return null
            return parsed.tierDiscountInfo
        } catch (e) {
            return null
        }
    }

    function writeDiscountCache(data) {
        try {
            sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), tierDiscountInfo: data }))
        } catch (e) {}
    }

    function formatPrice(val) {
        return 'R$ ' + val.toFixed(2).replace('.', ',')
    }

    function formatCents(cents) {
        return formatPrice(cents / 100)
    }

    function totalQty() {
        var total = 0
        trackedIds.forEach(function (vid) { total += widgetState[vid] })
        return total
    }

    function getDiscountPercentForQty(qty) {
        if (qty <= 0) return 0
        if (qty === 1) return tierDiscountInfo[1].discountPercent
        if (qty === 2) return tierDiscountInfo[2].discountPercent
        return tierDiscountInfo[3].discountPercent
    }

    // Subtotal 100% local: soma o preço real de cada variante (já vem no HTML)
    // e aplica o % de desconto real descoberto no probe — sem tocar no carrinho.
    function computeLocalSubtotal() {
        var rawCents = 0
        trackedIds.forEach(function (vid) {
            rawCents += (priceByVariant[vid] || 0) * widgetState[vid]
        })

        var percent = probingDone ? getDiscountPercentForQty(totalQty()) : 0
        var currentCents = percent > 0 ? Math.round(rawCents * (1 - percent / 100)) : rawCents

        preview = { currentCents: currentCents, compareCents: rawCents }
    }

    function applyDiscountTag(el, visible, text) {
        if (!el) return
        el.classList.remove('pdp-discount-tag-skeleton')
        if (visible) {
            if (text !== undefined) el.textContent = text
            el.style.display = ''
        } else {
            el.style.display = 'none'
        }
    }

    function cartUpdate(updates, opts) {
        opts = opts || {}
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(Object.assign({ updates: updates }, opts.extra || {})),
            keepalive: !!opts.keepalive,
        }).then(function (res) {
            if (!res.ok) throw new Error('Falha ao atualizar carrinho')
            return res.json()
        })
    }

    function setOriginalCart(cart) {
        var newOriginal = {}
        cart.items.forEach(function (item) {
            newOriginal[String(item.id)] = item.quantity
        })
        originalCart = newOriginal
    }

    function syncWidgetStateFromOriginal() {
        trackedIds.forEach(function (vid) {
            widgetState[vid] = originalCart[vid] || 0
        })
    }

    function buildRestoreUpdates() {
        var updates = {}
        for (var vid in originalCart) updates[vid] = originalCart[vid]
        trackedIds.forEach(function (vid) {
            if (!(vid in updates)) updates[vid] = 0
        })
        return updates
    }

    function buildCommitUpdates() {
        var updates = {}
        for (var vid in originalCart) updates[vid] = originalCart[vid]
        trackedIds.forEach(function (vid) {
            updates[vid] = widgetState[vid]
        })
        return updates
    }

    function recordTierResult(cart, variantId, qty) {
        var currentCents = 0
        var compareCents = 0

        cart.items.forEach(function (item) {
            if (String(item.id) === variantId) {
                currentCents += item.final_line_price
                compareCents += item.original_line_price
            }
        })

        var hasDiscount = compareCents > currentCents
        var discountPercent = hasDiscount ? Math.round(((compareCents - currentCents) / compareCents) * 100) : 0

        tierDiscountInfo[qty] = {
            hasDiscount: hasDiscount,
            discountPercent: discountPercent,
        }
    }

    // Testa isoladamente 1/2/3 unidades de uma variante de referência (zera o
    // resto do carrinho uma vez, troca a quantidade 3x, restaura uma vez no
    // fim) pra descobrir o desconto real por quantidade. Roda só quando não
    // há cache válido em sessionStorage.
    function probeTierDiscounts() {
        var refId = probeReferenceId
        if (!refId) {
            probingDone = true
            renderUI()
            return
        }

        var isolateUpdates = {}
        for (var vid in originalCart) isolateUpdates[vid] = 0
        trackedIds.forEach(function (vid) {
            if (!(vid in isolateUpdates)) isolateUpdates[vid] = 0
        })
        isolateUpdates[refId] = 3

        var setRefQty = function (qty) {
            var updates = {}
            updates[refId] = qty
            return cartUpdate(updates)
        }

        cartUpdate(isolateUpdates)
            .then(function (cart) {
                recordTierResult(cart, refId, 3)
                return setRefQty(2)
            })
            .then(function (cart) {
                recordTierResult(cart, refId, 2)
                return setRefQty(1)
            })
            .then(function (cart) {
                recordTierResult(cart, refId, 1)
                return cartUpdate(buildRestoreUpdates(), { keepalive: true })
            })
            .catch(function (err) {
                console.error('[pdp-bundle] erro ao pré-calcular tags de desconto da progressão', err)
                return cartUpdate(buildRestoreUpdates(), { keepalive: true }).catch(function () {})
            })
            .then(function () {
                probingDone = true
                writeDiscountCache(tierDiscountInfo)
                renderUI()
            })
    }

    function renderUI() {
        computeLocalSubtotal()
        var qty = totalQty()

        // Qualquer tier (1, 2 ou 3) pode mostrar % OFF, frete grátis, ou os dois
        // combinados (ex: "10% OFF + FRETE GRÁTIS") — não é fixo por tier, só
        // depende do que realmente está configurado/ativo pra aquela quantidade.
        // Frete grátis não depende do probe de rede (é só preço x qty vs. valor
        // mínimo), aparece na hora; o "% OFF" só entra depois que o probe confirmar.
        ;[1, 2, 3].forEach(function (tierQty) {
            var el = discountTagEls[tierQty]
            if (!el) return

            var parts = []
            if (probingDone && tierDiscountInfo[tierQty].hasDiscount) {
                parts.push(tierDiscountInfo[tierQty].discountPercent + '% OFF')
            }
            if (freeShippingInfoForQty(tierQty) && freeShippingTagText) {
                parts.push(freeShippingTagText)
            }
            var text = parts.join(' + ')
            applyDiscountTag(el, text !== '', text !== '' ? text : undefined)
        })

        cards.forEach(function (card) {
            var variantId = card.getAttribute('data-variant-id')
            var cardQty = widgetState[variantId]
            var addBtn = card.querySelector('.pdp-add-btn')
            var qtyControls = card.querySelector('.pdp-qty-controls')
            var qtyVal = card.querySelector('.pdp-qty-value')

            if (cardQty === 0) {
                card.classList.remove('active')
                if (addBtn) addBtn.style.display = 'block'
                if (qtyControls) qtyControls.style.display = 'none'
            } else {
                card.classList.add('active')
                if (addBtn) addBtn.style.display = 'none'
                if (qtyControls) qtyControls.style.display = 'flex'
                if (qtyVal) qtyVal.textContent = cardQty
            }
        })

        if (fillLine) {
            if (qty === 0) {
                fillLine.style.width = '0%'
                steps.forEach(function (s) { s.classList.remove('active') })
                bottomCols.forEach(function (col) { col.classList.remove('active') })
                topCols.forEach(function (col) { col.classList.remove('active') })
            } else if (qty === 1) {
                fillLine.style.width = '5%'
                fillLine.style.background = 'rgba(178, 217, 38, 0.50)'
                steps.forEach(function (s) {
                    var stepNum = parseInt(s.getAttribute('data-step'))
                    s.classList.toggle('active', stepNum === 1)
                })
                bottomCols.forEach(function (col, i) { col.classList.toggle('active', i === 0) })
                topCols.forEach(function (col, i) { col.classList.toggle('active', i === 0) })
            } else if (qty === 2) {
                fillLine.style.width = '50%'
                fillLine.style.background = 'rgba(178, 217, 38, 0.50)'
                steps.forEach(function (s) {
                    var stepNum = parseInt(s.getAttribute('data-step'))
                    s.classList.toggle('active', stepNum <= 2)
                })
                bottomCols.forEach(function (col, i) { col.classList.toggle('active', i <= 1) })
                topCols.forEach(function (col, i) { col.classList.toggle('active', i <= 1) })
            } else {
                fillLine.style.width = '100%'
                fillLine.style.background = 'rgba(178, 217, 38, 0.50)'
                steps.forEach(function (s) { s.classList.add('active') })
                bottomCols.forEach(function (col) { col.classList.add('active') })
                topCols.forEach(function (col) { col.classList.add('active') })
            }
        }

        if (qty === 0) {
            if (subtotalPrices) subtotalPrices.classList.remove('pdp-subtotal-prices--loading')
            if (subtotalCompare) subtotalCompare.style.display = 'none'
            subtotalCurrent.textContent = formatPrice(0)
            submitBtn.disabled = true
            return
        }

        var isCalculating = !initialized || !probingDone
        if (subtotalPrices) subtotalPrices.classList.toggle('pdp-subtotal-prices--loading', isCalculating)
        submitBtn.disabled = !initialized

        if (isCalculating) {
            // Não mostra o preço cheio (sem desconto) enquanto o desconto real
            // ainda não foi confirmado — evita o número "saltar" na frente do
            // cliente quando o probe termina.
            subtotalCurrent.textContent = ''
            if (subtotalCompare) subtotalCompare.style.display = 'none'
            return
        }

        subtotalCurrent.textContent = formatCents(preview.currentCents)

        if (subtotalCompare) {
            if (preview.compareCents > preview.currentCents) {
                subtotalCompare.style.display = 'inline'
                subtotalCompare.textContent = formatCents(preview.compareCents)
            } else {
                subtotalCompare.style.display = 'none'
            }
        }
    }

    // Confirma de fato a seleção no carrinho real, mesclada com o que já
    // existia (outros produtos não são afetados). Único momento em que o
    // carrinho real é tocado pra valer durante a navegação na PDP.
    function commitToCart() {
        if (totalQty() === 0) return

        submitBtn.disabled = true
        submitBtnText.textContent = 'Adicionando...'

        var cartComponent =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer')

        var sectionsParam = {}
        if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
            sectionsParam = {
                sections: cartComponent.getSectionsToRender().map(function (section) {
                    return section.id
                }),
                sections_url: window.location.pathname,
            }
        }

        cartUpdate(buildCommitUpdates(), { extra: sectionsParam })
            .then(function (cart) {
                setOriginalCart(cart)
                syncWidgetStateFromOriginal()

                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-bundle', cartData: cart })
                }

                submitBtnText.textContent = '✓ Adicionado!'
                submitBtn.style.backgroundColor = '#4CAF50'

                if (cartComponent && typeof cartComponent.renderContents === 'function') {
                    if (cartComponent.classList.contains('is-empty')) {
                        cartComponent.classList.remove('is-empty')
                    }
                    cartComponent.renderContents(cart)
                } else {
                    window.location.reload()
                }

                setTimeout(function () {
                    submitBtnText.textContent = originalBtnText
                    submitBtn.style.backgroundColor = originalBtnBg
                    renderUI()
                }, 2000)
            })
            .catch(function (err) {
                console.error(err)
                submitBtnText.textContent = 'Erro ao adicionar'
                submitBtn.style.backgroundColor = '#f44336'
                setTimeout(function () {
                    submitBtnText.textContent = originalBtnText
                    submitBtn.style.backgroundColor = originalBtnBg
                    renderUI()
                }, 2000)
            })
    }

    // Eventos dos Cards — só mexem no estado local, instantâneo, sem rede.
    cards.forEach(function (card) {
        var variantId = card.getAttribute('data-variant-id')
        var addBtn = card.querySelector('.pdp-add-btn')
        var plusBtn = card.querySelector('.pdp-qty-btn--plus')
        var minusBtn = card.querySelector('.pdp-qty-btn--minus')

        if (addBtn) {
            addBtn.addEventListener('click', function () {
                widgetState[variantId] = 1
                renderUI()
            })
        }

        if (plusBtn) {
            plusBtn.addEventListener('click', function (e) {
                e.stopPropagation()
                if (widgetState[variantId] < 10) {
                    widgetState[variantId]++
                    renderUI()
                }
            })
        }

        if (minusBtn) {
            minusBtn.addEventListener('click', function (e) {
                e.stopPropagation()
                if (widgetState[variantId] > 0) {
                    widgetState[variantId]--
                    renderUI()
                }
            })
        }
    })

    submitBtn.addEventListener('click', function (e) {
        e.preventDefault()
        if (submitBtn.disabled || totalQty() === 0) return
        commitToCart()
    })

    // Resincroniza com o carrinho real quando ele muda por fora do widget
    // (gaveta do carrinho, página do carrinho, outro componente da página).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (!event || !event.cartData || event.source === 'pdp-bundle') return
            setOriginalCart(event.cartData)
            syncWidgetStateFromOriginal()
            renderUI()
        })
    }

    var cachedTierDiscountInfo = readDiscountCache()
    if (cachedTierDiscountInfo) {
        tierDiscountInfo = cachedTierDiscountInfo
        probingDone = true
    }

    renderUI()
    fetch('/cart.js')
        .then(function (res) { return res.json() })
        .then(function (cart) {
            setOriginalCart(cart)
            syncWidgetStateFromOriginal()
            initialized = true
            renderUI()
            if (!probingDone) probeTierDiscounts()
        })
        .catch(function (err) {
            console.error(err)
            initialized = true
            if (!probingDone) probingDone = true
            renderUI()
        })
})()
